<template>
<Navbar v-if="this.lang == 'id'"></Navbar>
<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>

	<div class="klien">
		<div class="header-klien">
			<div class="container">
				<h1 v-if="this.lang == 'en'">Clients</h1>
				<h1 v-else-if="this.lang == 'id'">Klien</h1>
				<hr>
			</div>
		</div>

		<div class="clients">
			<div class="container">
				<table id="klien" class="klien">
					<thead>
						<tr>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="client in clients.slice().reverse()" :key="client.id">
							<td>
								<router-link :to="'/klien/'+client.id" class="link">
									<div class="card">
										<figure class="card-img-top">
											<img :src="imageUrl+client.image" class="card-img" alt="...">
										</figure>
										<div class="card-footer">
											<p class="card-text text-center" v-if="this.lang == 'id'">{{ client.nama_klien }}</p>
											<p class="card-text text-center" v-else-if="this.lang == 'en'">{{ client.nama_klien_en }}</p>
										</div>
									</div>
								</router-link>
							</td>
						</tr>
					</tbody>
				</table>
				<!-- <div class="row">
					<div class="col-lg-3 col-sm-12" v-for="client in clients" :key="client.id">
						<router-link :to="'/klien/'+client.id" class="link">
							<div class="card">
								<figure class="image-wrapper">
									<img :src="imageUrl+client.image" class="card-img" alt="...">
								</figure>
								<div class="card-footer">
									<p class="card-text text-center" v-if="this.lang == 'id'">{{ client.nama_klien }}</p>
									<p class="card-text text-center" v-else-if="this.lang == 'en'">{{ client.nama_klien_en }}</p>
								</div>
							</div>
						</router-link>
					</div>
				</div> -->
			</div>
		</div>
		

		<!-- <div class="klien-list" v-for="client in clients" :key="client.id">
			<img :src="noImage" class="klien-image" alt="" v-if="client.image === null">
			<img :src="imageUrl+client.image" class="klien-image" alt="" v-else>
			<div class="container">
				<div class="row">
					<div class="col-lg-5 col-md-12">
						<div class="text">
							<div v-if="this.lang == 'id'">
								<h6 class="dark-grey title">Klien Kami</h6>
								<h1 class="orange">{{ client.nama_klien }}</h1>
							</div>
							<div v-else-if="this.lang == 'en'">
								<h6 class="dark-grey title">Our Client</h6>
								<h1 class="orange">{{ client.nama_klien_en }}</h1>
							</div>
							<h6 class="purple detail"><router-link :to="'/klien/'+client.id"><hr> Detail</router-link></h6>
						</div>
					</div>
					<div class="col-lg-7 col-md-12">
						<img :src="noImage" alt="" class="p-image" v-if="client.image === null">
						<img :src="imageUrl+client.image" alt="" class="p-image" v-else>
					</div>
				</div>
			</div>
		</div> -->
	</div>
	<div class="langApp">
		<div class="btn-group dropstart">
			<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
				<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
					<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#0054a5"/>
				</svg>
			</button>
			<ul class="dropdown-menu">
				<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
				<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

			</ul>
		</div>
	</div>
	<Footer />
</template>

<script>
	// @ is an alias to /src
	import Footer from '@/components/Footer.vue'
	import Navbar from '@/components/Navbar.vue'
	import NavbarEn from '@/components/NavbarEn.vue'
	import axios from 'axios'
	import { onMounted, nextTick, ref } from 'vue'
	import 'jquery/dist/jquery.min.js'

	//Datatable Modules
	import "datatables.net-bs5/js/dataTables.bootstrap5"
	import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"
	import $ from 'jquery'
	
	export default {
		name: 'Klien',
		components: {
			Footer,
			Navbar,
			NavbarEn,
		},
		data() {
			return {
				activeLanguage: this.lang
			}
		},
		methods: {
			selectLanguage: function (lang) {
				this.activeLanguage = lang;
				this.lang = lang;
				
				localStorage.setItem("lang", lang);
			}
		},
		setup() {
			let clients = ref([]);

			onMounted(() => {
				axios.get('getKlien')
				.then((result) => {
					clients.value = result.data
					getClients()
				}).catch((err) => {
					console.log(err.response)
				})
			})

			function getClients(){
				nextTick(() => {
					$('#klien').DataTable({
						ordering: false,
						"pageLength": 12
					})
				})
			}

			return{
				clients,
				getClients
			}
		}
	}
</script>

<style>
	/* .header-klien{
		height: 120px;
	} */
	.header-klien{
		background: url(../assets/bg-decor.svg), var(--primary-g);
		background-size: cover;
		padding-top: 120px;
		padding-bottom: 50px;
	}
	.header-klien h1{
		color: white;
		text-align: center;
		padding-top: 50px;
	}
	.header-klien hr{
		background: var(--secondary-);
		height: 4px;
		width: 100px;
		opacity: 1;
		display: block;
		margin: 0 auto;
	}

	.clients{
		margin: 50px 0;
	}
	.clients table.klien{
		width: 100% !important;
	}
	.dataTable thead tr th.sorting{
		display: none !important;
	}
	.dataTables_length{
		display: none !important;
	}
	.dataTables_filter{
		display: none !important;
	}
	.dataTables_info{
		display: none !important;
	}

	/* ==== Pagination ===== */
	.dataTables_paginate{
		text-align: center !important;
		display: flex;
		justify-content: flex-end;
		width: 100%;
		flex-wrap: wrap;
		float: left;
	}
	.dataTables_paginate ul li{
		padding: 0 !important;
	}
	.dataTables_paginate .pagination .page-item.active .page-link{
		background: var(--primary-);
	}
	/* ==== Pagination ===== */

	.clients table.klien tbody tr{
		float: left;
		width: 25%;
		padding: 10px;
	}
	.clients table.klien tbody tr:after {
		content: "";
		display: table;
		clear: both;
	}
	.clients .link{
		text-decoration: none;
		transition: all 1s;
	}
	.clients .card{
		border: 1px solid #d8d8d8;
		box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
		margin-bottom: 10px;
	}
	.clients .card .card-footer p{
		color: var(--dark-grey-);
		line-height: 1.3;
		transition: all 1s;
	}
	.clients .card .card-footer p:hover{
		color: var(--primary-);
	}
	.clients .card .card-footer{
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.clients .card figure{
		width: 100% !important;
		height: 200px;
		margin: 0 !important;
		clip-path: inset(0 0 0 0);
	}
	.clients .card figure img.card-img{
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 0;
		transition: all 1s;
	}
	.clients .card figure img.card-img:hover{
		transform: scale(1.1);
	}

	.klien-list{
		position: relative;
		background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.8) 100%);
		width: 100%;
		/* height: 400px; */
		padding: 80px 0;
	}
	.klien-list .klien-image{
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
		z-index: -1;
	}
	.klien-list .text{
		text-align: right;
		padding: 0 15%;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
	}
	.klien-list .text h6.title{
		text-align: left;
		
	}
	.klien-list .text h6.detail{
		text-align: right;
		padding-top: 20px;
		position: relative;
	}
	.klien-list .text h6.detail a{
		color: var(--primary-);
		font-weight: 600;
		text-transform: uppercase;
		text-decoration: none;
		transition: 0.5s ease-in-out;
	}
	.klien-list .text h6.detail a:hover > hr{
		width: 50px;
	}
	.klien-list .text h6.detail a hr{
		width: 35px;
		height: 2px;
		background: var(--secondary-);
		opacity: 1;
		float: right;
		position: absolute;
		right: 60px;
		top: 12px;
		transition: 0.5s ease-in-out;
	}
	.klien-list .p-image{
		display: block;
		margin: 0 auto;
		width: 70%;
	}
	@media (max-width: 767.98px){
		.clients table.klien tbody tr{
			float: left;
			width: 50%;
			padding: 10px;
		}
	}
	@media (max-width: 549.98px){
		.clients table.klien tbody tr{
			float: left;
			width: 100%;
			padding: 10px 30px;
		}
		.dataTables_paginate{
			text-align: center !important;
			display: flex;
			justify-content: center;
			width: 100%;
			flex-wrap: wrap;
		}
	}
</style>
